import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-layout-wrapper',
  templateUrl: './layout-wrapper.component.html',
  styleUrls: ['./layout-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormlyField],
})
export class LayoutWrapperComponent extends FieldWrapper {
  get customProps() {
    return this.props['custom'] ?? {};
  }
}
